import { theme } from '@acorns/grove'
import React from 'react'
import { useMediaQuery } from 'react-responsive'

import { PageName } from 'generated/types'

import { ExternalNavbarProps, NavigationBar } from '../NavigationBar'
import {
  ContentContainer,
  FooterContainer,
  Headline,
  Page,
  Subtitle,
  BodyContainer,
  FooterTextContainer,
  ActionStrip,
  Image,
  ButtonContainer,
} from './styled-components'
import { FunnelContent } from '../FunnelContent'

interface Props {
  actionTitle: string // title of action strip
  headlineText: string // title of page
  subtitleText: string | React.ReactNode // subtitle of page
  imageUrl: string // background image
  pageName: PageName
  footer: React.ReactNode
  button: React.ReactNode
  children?: React.ReactNode
  navigationBar?: ExternalNavbarProps
  eventObjectName: string // this is the object name of the page that the user is currently on
}

export const ActionLayout = (props: Props) => {
  const isDesktop = useMediaQuery({ minWidth: `${theme.dimensions.breakpointsSmall + 1}px` })

  return (
    <div>
      <FunnelContent pageName={props.pageName} eventObjectName={props.eventObjectName} />
      <NavigationBar
        {...props.navigationBar}
        pageName={props.pageName}
        eventObjectName={props.eventObjectName}
        backgroundColor={!isDesktop && theme.colors.naturalDarkOak}
        showBackButton={!isDesktop}
        hasWhitePage={!isDesktop}
      />
      <Page
        image={props.imageUrl}
        navigation={
          isDesktop && (
            <ActionStrip
              title={props.actionTitle}
              sticky={false}
              onBack={props.navigationBar?.backOverride}
              preventDefault={true}
            />
          )
        }
        content={
          <>
            <ContentContainer>
              {!isDesktop && <Image src={props.imageUrl} aria-label="product image" />}
              <Headline>{props.headlineText}</Headline>
              {props.subtitleText && <Subtitle>{props.subtitleText}</Subtitle>}
              <BodyContainer>{props.children}</BodyContainer>
            </ContentContainer>
            <FooterContainer>
              <FooterTextContainer>{props.footer}</FooterTextContainer>
              <ButtonContainer>{props.button}</ButtonContainer>
            </FooterContainer>
          </>
        }
      />
    </div>
  )
}
